<template>
  <el-carousel arrow="always" class="banner" height="220px" :indicator-position="indicator">
    <el-carousel-item v-for="item in imgs" :key="item.id">
      <a :href="item.link" target="_blank" v-trace-click="'n.3839.7339.0'" v-if="item.link">
        <img :src="item.img_url" alt width="1200" height="220" />
      </a>
      <img :src="item.img_url" alt width="1200" height="220" v-else />
    </el-carousel-item>
  </el-carousel>
</template>
<script>
export default {
  name: "banner",
  data() {
    return {
      params: {
        code: "dynamic",
        preview: 0
      },
      imgs: [],
      indicator: ""
    };
  },
  created() {
    this.getAdvList();
  },
  methods: {
    getAdvList() {
      if (this.$route.query.preview) this.params.preview = 1;
      _api.product.getAdvList(this.params).then(res => {
        this.imgs = res.data;
        if (this.imgs.length == 1) {
          this.indicator = "none";
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.banner {
  width: 1200px;
  height: 220px;
  border-radius: 4px;
  background-color: rgba(24, 144, 255, 0.1);
  margin-top: 40px;
}
</style>
